import { resolve, relative } from 'path';
import type { Config } from 'tailwindcss';
import { config as baseConfig } from '../configs/config-look25';

type ConfigWithoutContent = Omit<Config, 'content'>;

type CreateTailwindConfigArgs = {
  /**
   * Provide the dirname of the directory you invoke this function from. Eg. `__dirname`.
   */
  dirname: string;

  /**
   * Provide the paths where your Tailwind classes are used.
   */
  content: string[];

  /**
   * Provide a custom Tailwind config if required.
   */
  config?: ConfigWithoutContent;
};

export const createTailwindConfig = ({
  dirname,
  content,
  config = {},
}: CreateTailwindConfigArgs): Config => {
  return {
    ...config,
    presets: [baseConfig],
    content: createContentAttribute({
      dirname,
      patterns: content,
    }),
  };
};

const createContentAttribute = (args: {
  dirname: string;
  patterns: string[];
}): string[] => {
  const { dirname, patterns } = args;

  const webCompositionsPath = resolve(
    __dirname,
    '../../../web-compositions/src/compositions',
  );

  const coreComponentsPath = resolve(
    __dirname,
    '../../../../node_modules/@tui-cruises/mein-schiff-web-react-component-library/src/components',
  );

  return [
    relative(dirname, webCompositionsPath) + '/**/*.{js,ts,jsx,tsx,mdx}',
    relative(dirname, coreComponentsPath) + '/**/*.{js,ts,jsx,tsx,mdx}',
    ...patterns,
  ];
};
